import { ref, computed, reactive } from 'vue'
import { defineStore } from 'pinia'
import { type Department } from './types'
import { faker } from '@faker-js/faker'
import axios from 'axios'

const apiURL: string = import.meta.env.VITE_API_URL + '/api'

const api = axios.create({
  baseURL: apiURL + '/v1'
})

export const useDepartmentStore = defineStore('department', () => {
  const departments = reactive(Array<Department>())
  const selectedDepartment = ref({} as Department) // selected in table
  const thisDepartment = ref({} as Department) //for form editing

  const showForm = ref(false)


  function generateDepartments(count = 100) {

  }


  async function saveDepartment(payload: Department) {
    if (payload.uuid) {
      const response = (await api.put('/departments/' + payload.uuid, payload))

      if (response.status == 200) {
        departments.push(response.data)
      } else {
      }
    } else {
      const response = (await api.post('/departments.json', payload))

      if (response.status == 200) {
        departments.push(response.data)
      } else {
      }
    }
  }


  async function addDepartment(payload: Department) {
    const response = (await api.post('/departments.json', payload))

    if (response.status == 200) {
      departments.push(response.data)
    } else {
    }


  }

  async function deleteDepartment(payload: Department) {
    const response = (await api.delete('/departments/' + payload.uuid))

    if (response.status == 200) {
      const idx = departments.findIndex(item=>item.uuid == payload.uuid)
      departments.splice(idx,1)
    } else {
    }


  }

  const departmentName = computed(()=>(uuid: string) => {
    return departments.find((item: Department)=> item.uuid == uuid)?.name
  })

  const departmentUuid = computed(()=>(name: string) => {
    return departments.find((item: Department)=> item.name.toLocaleLowerCase() == name.toLocaleLowerCase())?.uuid
  })

  async function getDepartments() {

    const response = (await api.get('/departments.json'))
    if (response.status == 200) {
      departments.length=0
      response.data.data.forEach((item: Department)=>{
        departments.push(item)
      })
      
    } else {
    }
  }



  return {
    showForm,
    departments,
    selectedDepartment,
    thisDepartment,
    generateDepartments,
    getDepartments,
    saveDepartment,
    addDepartment,
    deleteDepartment,
    departmentName,
    departmentUuid
  }
})
